var _rect, _path, _path2, _path3, _path4, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUnlimited = function SvgUnlimited(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 134,
    height: 80,
    viewBox: "0 0 134 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "unlimited_svg__mask0_9773_32828",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 134,
    height: 80
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 134,
    height: 80,
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#unlimited_svg__mask0_9773_32828)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.4721 70.7948C50.0517 73.9712 59.9471 69.8617 67.4458 62.2012L90.3168 39.2516C92.9926 36.6052 100.056 29.8168 103.665 32.5577C105.284 33.74 105.222 36.761 104.91 38.4729C103.914 44.4211 100.741 47.0367 96.8514 46.0088C105.563 50.2441 115.521 48.4065 116.019 36.1064C115.926 14.6215 96.2909 18.0467 85.6181 28.7271L59.8527 54.5098C44.3878 70.0484 26.9938 53.981 28.5194 37.7265C30.0126 21.7833 44.9799 10.9162 58.2974 24.3985C51.8568 17.0188 41.5262 14.4969 32.4086 18.0155C23.6337 21.4407 17.8149 29.8168 17.628 39.1583C17.4414 52.8284 26.061 66.7782 39.4721 70.7948Z",
    fill: "url(#unlimited_svg__paint0_linear_9773_32828)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M84.8715 44.7324L90.3172 39.2516C90.8769 38.6915 91.6551 37.944 92.5266 37.134L84.9335 29.4434L77.2795 37.0715L84.8715 44.732V44.7324Z",
    fill: "url(#unlimited_svg__paint1_linear_9773_32828)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0559 51.551L88.1691 41.3994L80.6084 33.7389L70.4952 43.8905L78.0559 51.551Z",
    fill: "url(#unlimited_svg__paint2_linear_9773_32828)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "unlimited_svg__mask1_9773_32828",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 7,
    width: 100,
    height: 51
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4086 18.0147C41.5261 14.4961 51.4204 17.4547 58.2973 24.3977L82.413 48.7479C95.5127 62.0137 112.316 59.4294 115.552 40.2785C115.832 38.7842 115.957 37.4141 116.019 36.1053C115.428 50.8964 99.2789 50.4609 90.0681 41.1506L65.9525 16.8005C46.3802 -3.00386 20.1488 11.2576 17.7524 36.6978C17.6904 37.5386 17.6591 38.3475 17.6279 39.1575C17.8149 29.816 23.6337 21.44 32.4086 18.0147Z",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#unlimited_svg__mask1_9773_32828)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#unlimited_svg__filter0_f_9773_32828)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.2049 91.9876C21.0546 91.5195 27.921 90.9925 34.7625 90.5538C41.281 90.1097 43.2807 86.7619 46.1004 76.1989C52.5548 51.8976 59.6471 27.5212 66.5571 3.15796C67.7463 -1.05437 66.7893 -4.33196 64.4204 -4.16008C47.5734 -2.93775 30.7098 -1.7142 13.8794 -0.550768L14.2049 91.9876Z",
    fill: "#FFB9F8"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#unlimited_svg__filter1_f_9773_32828)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100.784 86.6492C101.934 84.9461 103.054 83.1972 104.22 81.5171C105.316 79.8974 103.747 77.0799 98.0672 68.8854C84.9943 50.0395 72.0099 31.0123 58.9954 12.0309C56.744 8.75024 54.5998 6.57255 54.2077 7.16872C51.4197 11.4086 48.6289 15.6527 45.8093 19.8467L100.784 86.6492Z",
    fill: "#FFB9F8"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#unlimited_svg__filter2_f_9773_32828)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M131.913 80.7509C133.578 78.266 135.211 75.7352 136.892 73.2732C138.477 70.9094 136.989 67.9691 131.297 59.7935C118.193 40.9948 105.225 21.9431 92.2126 2.95791C89.9612 -0.322796 87.6729 -2.2814 87.1032 -1.41516C83.0522 4.74547 78.9971 10.9122 74.9146 17.0269L131.913 80.7509Z",
    fill: "#FFB9F8"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#unlimited_svg__filter3_f_9773_32828)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.36 76.6399C118.092 79.5074 127.819 82.3819 137.557 85.2556C130.953 80.8754 123.328 76.6076 115.572 72.6008C108.605 69.0048 101.285 65.4138 96.132 61.4205C91.7768 58.0471 89.2577 54.6377 87.5041 51.2179C80.4487 46.3962 75.5174 41.3743 72.9252 36.1526C70.9894 32.2482 74.4214 32.3462 75.5136 29.0748C81.4044 32.9101 80.9853 26.3957 75.3207 22.4531C73.0007 20.8383 73.2525 21.8429 71.4734 20.1684C70.237 18.9963 66.8575 18.3578 66.2133 17.1961C63.2964 11.8911 46.9815 5.80255 45.2759 0.606319C37.8388 4.00034 51.4319 13.5319 48.7726 18.4898C62.0771 27.667 63.7439 32.7256 69.2956 42.2049C69.7508 42.9856 70.173 43.765 70.5833 44.5451L100.06 73.9508C102.784 74.9119 105.553 75.8103 108.36 76.6399Z",
    fill: "#71BBFF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#unlimited_svg__filter4_f_9773_32828)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M142.92 70.1534C142.922 70.1572 142.917 70.16 142.913 70.1573C128.046 60.0323 112.981 45.8806 99.6519 29.2177C95.2742 23.7351 87.4677 20.669 80.9557 22.1684C79.7357 22.4493 78.5159 22.7305 77.2963 23.012C64.6025 25.9418 62.713 39.7813 73.7255 48.9242L97.124 68.3502C104.163 74.1946 113.842 76.7389 121.972 74.8951C128.951 73.3123 135.932 71.735 142.914 70.1505C142.916 70.1499 142.919 70.1512 142.92 70.1534Z",
    fill: "#FFE665"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#unlimited_svg__filter5_f_9773_32828)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.8752 31.7473C87.4001 31.7633 87.6275 31.9896 88.2435 32.1145C88.7526 32.8116 89.3159 31.9474 89.1982 31.2528C89.0325 30.2745 88.4507 30.4979 87.879 30.1694C86.8765 29.5935 86.1535 29.3341 85.2179 28.4779C84.5304 27.8487 83.7317 25.6725 83.4657 24.705C83.0695 23.2637 80.9908 23.5169 80.0013 23.2631C78.5754 22.8974 77.3331 23.1284 76.0291 22.1141C74.737 21.109 73.841 19.5937 72.8292 18.2628C71.7098 16.7904 70.8583 15.7103 69.0838 15.2552C67.5777 14.8689 66.9461 16.4781 66.2724 17.4309C65.609 18.3692 66.204 20.3698 66.4444 21.4621C66.7554 22.8752 67.4329 23.597 68.2911 24.6535C69.2464 25.8295 71.0554 25.9628 71.9757 27.0957C72.7067 27.9957 73.6007 30.0582 74.8154 30.1766C77.2121 30.4101 79.208 29.9198 81.3193 31.852C82.1245 32.5888 83.973 32.0803 84.9007 31.8755C85.6289 31.7149 86.1589 31.7255 86.8752 31.7473Z",
    fill: "#0A9F68"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "unlimited_svg__filter0_f_9773_32828",
    x: 5.87939,
    y: -12.1665,
    width: 69.1887,
    height: 112.154,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "effect1_foregroundBlur_9773_32828"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "unlimited_svg__filter1_f_9773_32828",
    x: 37.8093,
    y: -0.929565,
    width: 74.7371,
    height: 95.5787,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "effect1_foregroundBlur_9773_32828"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "unlimited_svg__filter2_f_9773_32828",
    x: 66.9146,
    y: -9.62012,
    width: 78.5725,
    height: 98.371,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "effect1_foregroundBlur_9773_32828"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "unlimited_svg__filter3_f_9773_32828",
    x: 35.0239,
    y: -7.39368,
    width: 110.533,
    height: 100.649,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "effect1_foregroundBlur_9773_32828"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "unlimited_svg__filter4_f_9773_32828",
    x: 58.5037,
    y: 13.7889,
    width: 92.4167,
    height: 69.6978,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "effect1_foregroundBlur_9773_32828"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "unlimited_svg__filter5_f_9773_32828",
    x: 57.9688,
    y: 7.19641,
    width: 39.2451,
    height: 33.1757,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "effect1_foregroundBlur_9773_32828"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "unlimited_svg__paint0_linear_9773_32828",
    x1: 33.614,
    y1: 16.4478,
    x2: 70.7603,
    y2: 73.4763,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFEFEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "unlimited_svg__paint1_linear_9773_32828",
    x1: 82.2437,
    y1: 38.6564,
    x2: 88.873,
    y2: 34.2494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1F1F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "unlimited_svg__paint2_linear_9773_32828",
    x1: 81.2105,
    y1: 39.6893,
    x2: 73.9753,
    y2: 47.6374,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1F1F1"
  })))));
};
export default SvgUnlimited;